<template>
    <form-row title="Has Your Mortgage/Loan Application Been Signed?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="has_mortgage_application_been_signed"
                v-model="has_been_signed"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="has_been_signed"
                class="mt-4 sm:mt-0 sm:ml-12 flex flex-1 items-center sm:justify-end"
                label="Date Signed:"
                :value="mortgage.mortgage_application_signed_at"
                name="mortgage_application_signed_at"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        mortgage: {},
        read_only: { default: false },
    },

    data() {
        return {
            has_been_signed: this.mortgage.has_mortgage_application_been_signed,
        }
    },
}
</script>
